// extracted by mini-css-extract-plugin
module.exports = {"divider":"VrmLookupOrCall_divider__6aVAH","line":"VrmLookupOrCall_line__2g3VZ","callUs":"VrmLookupOrCall_callUs__yNlIp"};